import moment from "moment";

export function formatDateMoment(stringDate:any, formatMoment:any, formatFinal:any) {
    const date = moment(stringDate, formatMoment);
    return date.isValid() ? date.format(formatFinal) : "";
}

export function formatPercentage(value:any) {
    return value.toString().replace(".", ",");
}

const numberFormatterDecimal = (c:any, i:any, a:any) =>
    i && c !== "." && (a.length - i) % 3 === 0 ? `.${c}` : c;

export const formatNumberDecimal = (number:any) =>
    number.toString().replace(/./g, numberFormatterDecimal);